import { ChangeDetectionStrategy, Component, ElementRef, ViewChild } from '@angular/core';
import { LanguageService } from '@spartacus/core';
import { ExportCsvFileService, ExportFileOptions } from '@spartacus/storefront';
import { CSVHeaders, User, UserTableColumnHeader } from '../../model/user-page-model';
import { UsersService } from '../../services/users.service';
import { UsersTrackingService } from '../../services/users-tracking.service';

@Component({
  selector: 'app-csv-download',
  templateUrl: './csv-download.component.html',
  styleUrl: './csv-download.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CSVDownloadComponent {

  translations = {
    es: {
      Name: UserTableColumnHeader.NAME,
      Username: UserTableColumnHeader.USER_NAME,
      AlternativeEmail: UserTableColumnHeader.ALTERNATIVE_EMAIL,
      Company: UserTableColumnHeader.COMPANY,
      LegalEntities: UserTableColumnHeader.LEGAL_ENTITIES,
    },
    en: {
      Name: UserTableColumnHeader.NAME,
      Username: UserTableColumnHeader.USER_NAME,
      AlternativeEmail: UserTableColumnHeader.ALTERNATIVE_EMAIL,
      Company: UserTableColumnHeader.COMPANY,
      LegalEntities: UserTableColumnHeader.LEGAL_ENTITIES,
    },
    de: {
      Name: UserTableColumnHeader.NAME,
      Username: UserTableColumnHeader.USER_NAME,
      AlternativeEmail: UserTableColumnHeader.ALTERNATIVE_EMAIL,
      Company: UserTableColumnHeader.COMPANY,
      LegalEntities: UserTableColumnHeader.LEGAL_ENTITIES,
    },
  };
  @ViewChild('csvDownload', { static: false }) csvDownload!: ElementRef

  constructor(
    private userService: UsersService,
    private languageService: LanguageService,
    private csvExportService: ExportCsvFileService,
    private userTracking: UsersTrackingService
  ) { }

  downloadCSV(): void {
    const headers = [
      CSVHeaders.NAME,
      CSVHeaders.USER_NAME,
      CSVHeaders.ALTERNATIVE_EMAIL,
      CSVHeaders.COMPANY,
      CSVHeaders.LEGAL_ENTITIES,
    ];

    const rows = this.userService.filteredData.map((row) => [
      row?.displayName || '-',
      row?.email || '-',
      row?.alternativeEmail || '-',
      row?.company || '-',
      row.legalEntityCount.toString(),
    ]);

    this.languageService.getActive().subscribe((lang) => {
      const translatedHeaders = this.translateArray(headers, lang as 'en' | 'es' | 'de');
      const data = [translatedHeaders, ...rows];

      const exportOptions: ExportFileOptions = {
        fileName: User.USERS,
        extension: User.CSV,
        type: User.CSV_TEXT,
      };

      this.csvExportService.download(data, ',', exportOptions);
    });
    this.userTracking.trackDocumentEvent(this.csvDownload.nativeElement)
  }

  translateArray(arr: string[], lang: 'en' | 'es' | 'de'): string[] {
    return arr.map((value) => this.translations[lang][value] || value);
  }
}
